import React from 'react';
import GatsbyLink from 'gatsby-link';
import Helmet from 'react-helmet';

import Intro from '../components/intro';

import Link from '../components/Link';

import '../css/index.scss';

export default function Index({ data }) {
  const { edges: posts } = data.allMarkdownRemark;
  return (

<main id="main">

    <div className="blog-posts">

    <div id="in">
      <h1>We are a growing community of artists and designers, building bold + radical experiences for the web-browser. We conduct interviews, organize coding-challenges, give talks and swap ideas in our official facebook-group. |</h1>
    </div>
    <hr/>
      {posts
        .filter(post => post.node.frontmatter.title.length > 0)
        .map(({ node: post }) => {
          return (
            <div className="blog-post-preview" key={post.id}>

              <h1 className="title">
                <GatsbyLink to={post.frontmatter.path}>
                  {post.frontmatter.title}
                </GatsbyLink>
              </h1>
              <h4 className="date">
                {post.frontmatter.date}
              </h4>
              <p>
                {post.excerpt}
              </p>
              <Link to={post.frontmatter.path}>Read more</Link>
              <hr/>
            </div>

          );
        })}
    </div>

    </main>
  );

}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 250)
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js